import config from '@config';
import TrackingHelper from '@business/tracking/TrackingHelper';
import LazyLoadingHelper from './helpers/LazyLoadingHelper';
import CheckoutHelper from './helpers/CheckoutHelper';
import LayoutHelper from './helpers/LayoutHelper';
import HomePageHelper from '@helpers/HomePageHelper';

console.log('Dope script loaded. App version: ' + config.version);

addEventListener('load', () => {
    console.log('Page fully loaded.');
});

// Setup tracking
(new TrackingHelper()).setup();

// Lazy loading
(new LazyLoadingHelper()).setup();

// Checkout fixes
(new CheckoutHelper()).setup();

// Layout fixes
(new LayoutHelper()).setup();

// Home page 
(new HomePageHelper()).setup();